import { clsx } from 'clsx'
import { assignInlineVars } from '@vanilla-extract/dynamic'
import { tokens } from '../../theme/tokens.css'
import { dot, dots, dotsColor, staticDot } from './LoadingDots.css'

type Props = {
  color?: string
  /**
   * Accessible label for the loading indicator.
   * @default "Loading"
   */
  label?: string
  /**
   * When false, the dots are shown fully opaque without animation, as a decorative element.
   * @default true
   */
  isAnimated?: boolean
}

export function LoadingDots({
  color = tokens.colors.text.opaque.primary,
  label = 'Loading',
  isAnimated = true,
}: Props) {
  const dotClassName = clsx(dot, !isAnimated && staticDot)

  return (
    <div
      style={assignInlineVars({ [dotsColor]: color })}
      className={dots}
      {...(isAnimated ? { role: 'status', 'aria-label': label, 'aria-live': 'polite' } : { 'aria-hidden': true })}
    >
      <span className={dotClassName} />
      <span className={dotClassName} />
      <span className={dotClassName} />
    </div>
  )
}
